export const countryTimezones = [
  "Africa/Abidjan (GMT) GMT +00:00",
  "Africa/Accra (GMT) GMT +00:00",
  "Africa/Addis Ababa (EAT) GMT +03:00",
  "Africa/Algiers (CET) GMT +01:00",
  "Africa/Asmara (EAT) GMT +03:00",
  "Africa/Bamako (GMT) GMT +00:00",
  "Africa/Bangui (WAT) GMT +01:00",
  "Africa/Banjul (GMT) GMT +00:00",
  "Africa/Bissau (GMT) GMT +00:00",
  "Africa/Blantyre (CAT) GMT +02:00",
  "Africa/Brazzaville (WAT) GMT +01:00",
  "Africa/Bujumbura (CAT) GMT +02:00",
  "Africa/Cairo (EET) GMT +02:00",
  "Africa/Casablanca (+01) GMT +01:00",
  "Africa/Ceuta (CET) GMT +01:00",
  "Africa/Conakry (GMT) GMT +00:00",
  "Africa/Dakar (GMT) GMT +00:00",
  "Africa/Dar es Salaam (EAT) GMT +03:00",
  "Africa/Djibouti (EAT) GMT +03:00",
  "Africa/Douala (WAT) GMT +01:00",
  "Africa/El Aaiun (+01) GMT +01:00",
  "Africa/Freetown (GMT) GMT +00:00",
  "Africa/Gaborone (CAT) GMT +02:00",
  "Africa/Harare (CAT) GMT +02:00",
  "Africa/Johannesburg (SAST) GMT +02:00",
  "Africa/Juba (CAT) GMT +02:00",
  "Africa/Kampala (EAT) GMT +03:00",
  "Africa/Khartoum (CAT) GMT +02:00",
  "Africa/Kigali (CAT) GMT +02:00",
  "Africa/Kinshasa (WAT) GMT +01:00",
  "Africa/Lagos (WAT) GMT +01:00",
  "Africa/Libreville (WAT)	        GMT +01:00",
  "Africa/Lome (GMT) GMT +00:00",
  "Africa/Luanda (WAT) GMT +01:00",
  "Africa/Lubumbashi (CAT) GMT +02:00",
  "Africa/Lusaka (CAT) GMT +02:00",
  "Africa/Malabo (WAT) GMT +01:00",
  "Africa/Maputo (CAT) GMT +02:00",
  "Africa/Maseru (SAST) GMT +02:00",
  "Africa/Mbabane (SAST) GMT +02:00",
  "Africa/Mogadishu (EAT) GMT +03:00",
  "Africa/Monrovia (GMT) GMT +00:00",
  "Africa/Nairobi (EAT) GMT +03:00",
  "Africa/Ndjamena (WAT) GMT +01:00",
  "Africa/Niamey (WAT) GMT +01:00",
  "Africa/Nouakchott (GMT) GMT +00:00",
  "Africa/Ouagadougou (GMT) GMT +00:00",
  "Africa/Porto-Novo (WAT) GMT +01:00",
  "Africa/Sao Tome (GMT) GMT +00:00",
  "Africa/Tripoli (EET) GMT +02:00",
  "Africa/Tunis (CET) GMT +01:00",
  "Africa/Windhoek (CAT) GMT +02:00",
  "America/Adak (HST) GMT -10:00",
  "America/Anchorage (AKST) GMT -09:00",
  "America/Anguilla (AST) GMT -04:00",
  "America/Antigua (AST) GMT -04:00",
  "America/Araguaina (-03) GMT -03:00",
  "America/Argentina/Buenos Aires (-03) GMT -03:00",
  "America/Argentina/Catamarca (-03) GMT -03:00",
  "America/Argentina/Cordoba (-03) GMT -03:00",
  "America/Argentina/Jujuy (-03) GMT -03:00",
  "America/Argentina/La Rioja (-03) GMT -03:00",
  "America/Argentina/Mendoza (-03) GMT -03:00",
  "America/Argentina/Rio Gallegos (-03) GMT -03:00",
  "America/Argentina/Salta (-03) GMT -03:00",
  "America/Argentina/San Juan (-03) GMT -03:00",
  "America/Argentina/San Luis (-03) GMT -03:00",
  "America/Argentina/Tucuman (-03) GMT -03:00",
  "America/Argentina/Ushuaia (-03) GMT -03:00",
  "America/Aruba (AST) GMT -04:00",
  "America/Asuncion (-03) GMT -03:00",
  "America/Atikokan (EST) GMT -05:00",
  "America/Bahia (-03) GMT -03:00",
  "America/Bahia Banderas (CST) GMT -06:00",
  "America/Barbados (AST) GMT -04:00",
  "America/Belem (-03) GMT -03:00",
  "America/Belize (CST) GMT -06:00",
  "America/Blanc-Sablon (AST) GMT -04:00",
  "America/Boa Vista (-04) GMT -04:00",
  "America/Bogota (-05) GMT -05:00",
  "America/Boise (MST) GMT -07:00",
  "America/Cambridge Bay (MST) GMT -07:00",
  "America/Campo Grande (-04) GMT -04:00",
  "America/Cancun (EST) GMT -05:00",
  "America/Caracas (-04) GMT -04:00",
  "America/Cayenne (-03) GMT -03:00",
  "America/Cayman (EST) GMT -05:00",
  "America/Chicago (CST) GMT -06:00",
  "America/Chihuahua (CST) GMT -06:00",
  "America/Costa Rica (CST) GMT -06:00",
  "America/Creston (MST) GMT -07:00",
  "America/Cuiaba (-04) GMT -04:00",
  "America/Curacao (AST) GMT -04:00",
  "America/Danmarkshavn (GMT) GMT +00:00",
  "America/Dawson (MST) GMT -07:00",
  "America/Dawson Creek (MST) GMT -07:00",
  "America/Denver (MST) GMT -07:00",
  "America/Detroit (EST) GMT -05:00",
  "America/Dominica (AST) GMT -04:00",
  "America/Edmonton (MST) GMT -07:00",
  "America/Eirunepe (-05) GMT -05:00",
  "America/El Salvador (CST) GMT -06:00",
  "America/Fort Nelson (MST) GMT -07:00",
  "America/Fortaleza (-03) GMT -03:00",
  "America/Glace Bay (AST) GMT -04:00",
  "America/Goose Bay (AST) GMT -04:00",
  "America/Grand Turk (EST) GMT -05:00",
  "America/Grenada (AST) GMT -04:00",
  "America/Guadeloupe (AST) GMT -04:00",
  "America/Guatemala (CST) GMT -06:00",
  "America/Guayaquil (-05) GMT -05:00",
  "America/Guyana (-04) GMT -04:00",
  "America/Halifax (AST) GMT -04:00",
  "America/Havana (CST) GMT -05:00",
  "America/Hermosillo (MST) GMT -07:00",
  "America/Indiana/Indianapolis (EST) GMT -05:00",
  "America/Indiana/Knox (CST) GMT -06:00",
  "America/Indiana/Marengo (EST) GMT -05:00",
  "America/Indiana/Petersburg (EST) GMT -05:00",
  "America/Indiana/Tell City (CST) GMT -06:00",
  "America/Indiana/Vevay (EST) GMT -05:00",
  "America/Indiana/Vincennes (EST) GMT -05:00",
  "America/Indiana/Winamac (EST) GMT -05:00",
  "America/Inuvik (MST) GMT -07:00",
  "America/Iqaluit (EST) GMT -05:00",
  "America/Jamaica (EST) GMT -05:00",
  "America/Juneau (AKST) GMT -09:00",
  "America/Kentucky/Louisville (EST) GMT -05:00",
  "America/Kentucky/Monticello (EST) GMT -05:00",
  "America/Kralendijk (AST) GMT -04:00",
  "America/La Paz (-04) GMT -04:00",
  "America/Lima (-05) GMT -05:00",
  "America/Los Angeles (PST) GMT -08:00",
  "America/Lower Princes (AST) GMT -04:00",
  "America/Maceio (-03) GMT -03:00",
  "America/Managua (CST) GMT -06:00",
  "America/Manaus (-04) GMT -04:00",
  "America/Marigot (AST) GMT -04:00",
  "America/Martinique (AST) GMT -04:00",
  "America/Matamoros (CST) GMT -06:00",
  "America/Mazatlan (MST) GMT -07:00",
  "America/Menominee (CST) GMT -06:00",
  "America/Merida (CST) GMT -06:00",
  "America/Metlakatla (AKST) GMT -09:00",
  "America/Mexico City (CST) GMT -06:00",
  "America/Miquelon (-03) GMT -03:00",
  "America/Moncton (AST) GMT -04:00",
  "America/Monterrey (CST) GMT -06:00",
  "America/Montevideo (-03) GMT -03:00",
  "America/Montserrat (AST) GMT -04:00",
  "America/Nassau (EST) GMT -05:00",
  "America/New York (EST) GMT -05:00",
  "America/Nome (AKST) GMT -09:00",
  "America/Noronha (-02) GMT -02:00",
  "America/North Dakota/Beulah (CST) GMT -06:00",
  "America/North Dakota/Center (CST) GMT -06:00",
  "America/North Dakota/New Salem (CST) GMT -06:00",
  "America/Nuuk (-03) GMT -03:00",
  "America/Ojinaga (CST) GMT -06:00",
  "America/Panama (EST) GMT -05:00",
  "America/Pangnirtung (EST) GMT -05:00",
  "America/Paramaribo (-03) GMT -03:00",
  "America/Phoenix (MST) GMT -07:00",
  "America/Port-au-Prince (EST) GMT -05:00",
  "America/Port of Spain (AST) GMT -04:00",
  "America/Porto Velho (-04) GMT -04:00",
  "America/Puerto Rico (AST) GMT -04:00",
  "America/Punta Arenas (-03) GMT -03:00",
  "America/Rankin Inlet (CST) GMT -06:00",
  "America/Recife (-03) GMT -03:00",
  "America/Regina (CST) GMT -06:00",
  "America/Resolute (CST) GMT -06:00",
  "America/Rio Branco (-05) GMT -05:00",
  "America/Santarem (-03) GMT -03:00",
  "America/Santiago (-03) GMT -03:00",
  "America/Santo Domingo (AST) GMT -04:00",
  "America/Sao Paulo (-03) GMT -03:00",
  "America/Scoresbysund (-01) GMT -01:00",
  "America/Sitka (AKST) GMT -09:00",
  "America/St Barthelemy (AST) GMT -04:00",
  "America/St Johns (NST) GMT -03:30",
  "America/St Kitts (AST) GMT -04:00",
  "America/St Lucia (AST) GMT -04:00",
  "America/St Thomas (AST) GMT -04:00",
  "America/St Vincent (AST) GMT -04:00",
  "America/Swift Current (CST) GMT -06:00",
  "America/Tegucigalpa (CST) GMT -06:00",
  "America/Thule (AST) GMT -04:00",
  "America/Tijuana (PST) GMT -08:00",
  "America/Toronto (EST) GMT -05:00",
  "America/Tortola (AST) GMT -04:00",
  "America/Vancouver (PST) GMT -08:00",
  "America/Whitehorse (MST) GMT -07:00",
  "America/Winnipeg (CST) GMT -06:00",
  "America/Yakutat (AKST) GMT -09:00",
  "America/Yellowknife (MST) GMT -07:00",
  "Antarctica/Casey (+11) GMT +11:00",
  "Antarctica/Davis (+07) GMT +07:00",
  "Antarctica/DumontDUrville (+10) GMT +10:00",
  "Antarctica/Macquarie (AEDT) GMT +11:00",
  "Antarctica/Mawson (+05) GMT +05:00",
  "Antarctica/McMurdo (NZDT) GMT +13:00",
  "Antarctica/Palmer (-03) GMT -03:00",
  "Antarctica/Rothera (-03) GMT -03:00",
  "Antarctica/Syowa (+03) GMT +03:00",
  "Antarctica/Troll (+00) GMT +00:00",
  "Antarctica/Vostok (+06) GMT +06:00",
  "Arctic/Longyearbyen (CET) GMT +01:00",
  "Asia/Aden (+03) GMT +03:00",
  "Asia/Almaty (+06) GMT +06:00",
  "Asia/Amman (+03) GMT +03:00",
  "Asia/Anadyr (+12) GMT +12:00",
  "Asia/Aqtau (+05) GMT +05:00",
  "Asia/Aqtobe (+05) GMT +05:00",
  "Asia/Ashgabat (+05) GMT +05:00",
  "Asia/Atyrau (+05) GMT +05:00",
  "Asia/Baghdad (+03) GMT +03:00",
  "Asia/Bahrain (+03) GMT +03:00",
  "Asia/Baku (+04) GMT +04:00",
  "Asia/Bangkok (+07) GMT +07:00",
  "Asia/Barnaul (+07) GMT +07:00",
  "Asia/Beirut (EET) GMT +02:00",
  "Asia/Bishkek (+06) GMT +06:00",
  "Asia/Brunei (+08) GMT +08:00",
  "Asia/Chita (+09) GMT +09:00",
  "Asia/Choibalsan (+08) GMT +08:00",
  "Asia/Colombo (+0530) GMT +05:30",
  "Asia/Damascus (+03) GMT +03:00",
  "Asia/Dhaka (+06) GMT +06:00",
  "Asia/Dili (+09) GMT +09:00",
  "Asia/Dubai (+04) GMT +04:00",
  "Asia/Dushanbe (+05) GMT +05:00",
  "Asia/Famagusta (EET) GMT +02:00",
  "Asia/Gaza (EET) GMT +02:00",
  "Asia/Hebron (EET) GMT +02:00",
  "Asia/Ho Chi Minh (+07) GMT +07:00",
  "Asia/Hong Kong (HKT) GMT +08:00",
  "Asia/Hovd (+07) GMT +07:00",
  "Asia/Irkutsk (+08) GMT +08:00",
  "Asia/Jakarta (WIB) GMT +07:00",
  "Asia/Jayapura (WIT) GMT +09:00",
  "Asia/Jerusalem (IST) GMT +02:00",
  "Asia/Kabul (+0430) GMT +04:30",
  "Asia/Kamchatka (+12) GMT +12:00",
  "Asia/Karachi (PKT) GMT +05:00",
  "Asia/Kathmandu (+0545) GMT +05:45",
  "Asia/Khandyga (+09) GMT +09:00",
  "Asia/Kolkata (IST) GMT +05:30",
  "Asia/Krasnoyarsk (+07) GMT +07:00",
  "Asia/Kuala Lumpur (+08) GMT +08:00",
  "Asia/Kuching (+08) GMT +08:00",
  "Asia/Kuwait (+03) GMT +03:00",
  "Asia/Macau (CST) GMT +08:00",
  "Asia/Magadan (+11) GMT +11:00",
  "Asia/Makassar (WITA) GMT +08:00",
  "Asia/Manila (PST) GMT +08:00",
  "Asia/Muscat (+04) GMT +04:00",
  "Asia/Nicosia (EET) GMT +02:00",
  "Asia/Novokuznetsk (+07) GMT +07:00",
  "Asia/Novosibirsk (+07) GMT +07:00",
  "Asia/Omsk (+06) GMT +06:00",
  "Asia/Oral (+05) GMT +05:00",
  "Asia/Phnom Penh (+07) GMT +07:00",
  "Asia/Pontianak (WIB) GMT +07:00",
  "Asia/Pyongyang (KST) GMT +09:00",
  "Asia/Qatar (+03) GMT +03:00",
  "Asia/Qostanay (+06) GMT +06:00",
  "Asia/Qyzylorda (+05) GMT +05:00",
  "Asia/Riyadh (+03) GMT +03:00",
  "Asia/Sakhalin (+11) GMT +11:00",
  "Asia/Samarkand (+05) GMT +05:00",
  "Asia/Seoul (KST) GMT +09:00",
  "Asia/Shanghai (CST) GMT +08:00",
  "Asia/Singapore (+08) GMT +08:00",
  "Asia/Srednekolymsk (+11) GMT +11:00",
  "Asia/Taipei (CST) GMT +08:00",
  "Asia/Tashkent (+05) GMT +05:00",
  "Asia/Tbilisi (+04) GMT +04:00",
  "Asia/Tehran (+0330) GMT +03:30",
  "Asia/Thimphu (+06) GMT +06:00",
  "Asia/Tokyo (JST) GMT +09:00",
  "Asia/Tomsk (+07) GMT +07:00",
  "Asia/Ulaanbaatar (+08) GMT +08:00",
  "Asia/Urumqi (+06) GMT +06:00",
  "Asia/Ust-Nera (+10) GMT +10:00",
  "Asia/Vientiane (+07) GMT +07:00",
  "Asia/Vladivostok (+10) GMT +10:00",
  "Asia/Yakutsk (+09) GMT +09:00",
  "Asia/Yangon (+0630) GMT +06:30",
  "Asia/Yekaterinburg (+05) GMT +05:00",
  "Asia/Yerevan (+04) GMT +04:00",
  "Atlantic/Azores (-01) GMT -01:00",
  "Atlantic/Bermuda (AST) GMT -04:00",
  "Atlantic/Canary (WET) GMT +00:00",
  "Atlantic/Cape Verde (-01) GMT -01:00",
  "Atlantic/Faroe (WET) GMT +00:00",
  "Atlantic/Madeira (WET) GMT +00:00",
  "Atlantic/Reykjavik (GMT) GMT +00:00",
  "Atlantic/South Georgia (-02) GMT -02:00",
  "Atlantic/St Helena (GMT) GMT +00:00",
  "Atlantic/Stanley (-03) GMT -03:00",
  "Australia/Adelaide (ACDT) GMT +10:30",
  "Australia/Brisbane (AEST) GMT +10:00",
  "Australia/Broken Hill (ACDT) GMT +10:30",
  "Australia/Darwin (ACST) GMT +09:30",
  "Australia/Eucla (+0845) GMT +08:45",
  "Australia/Hobart (AEDT) GMT +11:00",
  "Australia/Lindeman (AEST) GMT +10:00",
  "Australia/Lord Howe (+11) GMT +11:00",
  "Australia/Melbourne (AEDT) GMT +11:00",
  "Australia/Perth (AWST) GMT +08:00",
  "Australia/Sydney (AEDT) GMT +11:00",
  "Europe/Amsterdam (CET) GMT +01:00",
  "Europe/Andorra (CET) GMT +01:00",
  "Europe/Astrakhan (+04) GMT +04:00",
  "Europe/Athens (EET) GMT +02:00",
  "Europe/Belgrade (CET) GMT +01:00",
  "Europe/Berlin (CET) GMT +01:00",
  "Europe/Bratislava (CET) GMT +01:00",
  "Europe/Brussels (CET) GMT +01:00",
  "Europe/Bucharest (EET) GMT +02:00",
  "Europe/Budapest (CET) GMT +01:00",
  "Europe/Busingen (CET) GMT +01:00",
  "Europe/Chisinau (EET) GMT +02:00",
  "Europe/Copenhagen (CET) GMT +01:00",
  "Europe/Dublin (GMT) GMT +00:00",
  "Europe/Gibraltar (CET) GMT +01:00",
  "Europe/Guernsey (GMT) GMT +00:00",
  "Europe/Helsinki (EET) GMT +02:00",
  "Europe/Isle of Man (GMT) GMT +00:00",
  "Europe/Istanbul (+03) GMT +03:00",
  "Europe/Jersey (GMT) GMT +00:00",
  "Europe/Kaliningrad (EET) GMT +02:00",
  "Europe/Kirov (+03) GMT +03:00",
  "Europe/Kyiv (EET) GMT +02:00",
  "Europe/Lisbon (WET) GMT +00:00",
  "Europe/Ljubljana (CET) GMT +01:00",
  "Europe/London (GMT) GMT +00:00",
  "Europe/Luxembourg (CET) GMT +01:00",
  "Europe/Madrid (CET) GMT +01:00",
  "Europe/Malta (CET) GMT +01:00",
  "Europe/Mariehamn (EET) GMT +02:00",
  "Europe/Minsk (+03) GMT +03:00",
  "Europe/Monaco (CET) GMT +01:00",
  "Europe/Moscow (MSK) GMT +03:00",
  "Europe/Oslo (CET) GMT +01:00",
  "Europe/Paris (CET) GMT +01:00",
  "Europe/Podgorica (CET) GMT +01:00",
  "Europe/Prague (CET) GMT +01:00",
  "Europe/Riga (EET) GMT +02:00",
  "Europe/Rome (CET) GMT +01:00",
  "Europe/Samara (+04) GMT +04:00",
  "Europe/San Marino (CET) GMT +01:00",
  "Europe/Sarajevo (CET) GMT +01:00",
  "Europe/Saratov (+04) GMT +04:00",
  "Europe/Simferopol (MSK) GMT +03:00",
  "Europe/Skopje (CET) GMT +01:00",
  "Europe/Sofia (EET) GMT +02:00",
  "Europe/Stockholm (CET) GMT +01:00",
  "Europe/Tallinn (EET) GMT +02:00",
  "Europe/Tirane (CET) GMT +01:00",
  "Europe/Ulyanovsk (+04) GMT +04:00",
  "Europe/Vaduz (CET) GMT +01:00",
  "Europe/Vatican (CET) GMT +01:00",
  "Europe/Vienna (CET) GMT +01:00",
  "Europe/Vilnius (EET) GMT +02:00",
  "Europe/Volgograd (+03) GMT +03:00",
  "Europe/Warsaw (CET) GMT +01:00",
  "Europe/Zagreb (CET) GMT +01:00",
  "Europe/Zurich (CET) GMT +01:00",
  "Indian/Antananarivo (EAT) GMT +03:00",
  "Indian/Chagos (+06) GMT +06:00",
  "Indian/Christmas (+07) GMT +07:00",
  "Indian/Cocos (+0630) GMT +06:30",
  "Indian/Comoro (EAT) GMT +03:00",
  "Indian/Kerguelen (+05) GMT +05:00",
  "Indian/Mahe (+04) GMT +04:00",
  "Indian/Maldives (+05) GMT +05:00",
  "Indian/Mauritius (+04) GMT +04:00",
  "Indian/Mayotte (EAT) GMT +03:00",
  "Indian/Reunion (+04) GMT +04:00",
  "Pacific/Apia (+13) GMT +13:00",
  "Pacific/Auckland (NZDT) GMT +13:00",
  "Pacific/Bougainville (+11) GMT +11:00",
  "Pacific/Chatham (+1345) GMT +13:45",
  "Pacific/Chuuk (+10) GMT +10:00",
  "Pacific/Easter (-05) GMT -05:00",
  "Pacific/Efate (+11) GMT +11:00",
  "Pacific/Fakaofo (+13) GMT +13:00",
  "Pacific/Fiji (+12) GMT +12:00",
  "Pacific/Funafuti (+12) GMT +12:00",
  "Pacific/Galapagos (-06) GMT -06:00",
  "Pacific/Gambier (-09) GMT -09:00",
  "Pacific/Guadalcanal (+11) GMT +11:00",
  "Pacific/Guam (ChST) GMT +10:00",
  "Pacific/Honolulu (HST) GMT -10:00",
  "Pacific/Kanton (+13) GMT +13:00",
  "Pacific/Kiritimati (+14) GMT +14:00",
  "Pacific/Kosrae (+11) GMT +11:00",
  "Pacific/Kwajalein (+12) GMT +12:00",
  "Pacific/Majuro (+12) GMT +12:00",
  "Pacific/Marquesas (-0930) GMT -09:30",
  "Pacific/Midway (SST) GMT -11:00",
  "Pacific/Nauru (+12) GMT +12:00",
  "Pacific/Niue (-11) GMT -11:00",
  "Pacific/Norfolk (+12) GMT +12:00",
  "Pacific/Noumea (+11) GMT +11:00",
  "Pacific/Pago Pago (SST) GMT -11:00",
  "Pacific/Palau (+09) GMT +09:00",
  "Pacific/Pitcairn (-08) GMT -08:00",
  "Pacific/Pohnpei (+11) GMT +11:00",
  "Pacific/Port Moresby (+10) GMT +10:00",
  "Pacific/Rarotonga (-10) GMT -10:00",
  "Pacific/Saipan (ChST) GMT +10:00",
  "Pacific/Tahiti (-10) GMT -10:00",
  "Pacific/Tarawa (+12) GMT +12:00",
  "Pacific/Tongatapu (+13) GMT +13:00",
  "Pacific/Wake (+12) GMT +12:00",
  "Pacific/Wallis (+12) GMT +12:00",
  "UTC (UTC) GMT +00:00",
].map((element: any) => {
  return {
    label: element,
    value: element,
  };
});
